// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.headers {\r\n    font-size: 10px !important\n}\n.monthBox {\r\n  max-width: 200px;\r\n  margin-bottom: 10px;\n}\n.status {\r\n  color: red;\r\n  margin-left: -13px;\n}\r\n", ""]);
// Exports
module.exports = exports;
